import { jsx as _jsx } from "react/jsx-runtime";
import { CodeListing, Prose } from '@criteria-labs/react-typography';
export function ServersFigure({ service }) {
    var _a, _b;
    const urls = (_b = (_a = service.openAPI.servers) === null || _a === void 0 ? void 0 : _a.map((server) => server.url)) !== null && _b !== void 0 ? _b : [];
    if (urls.length === 0) {
        return null;
    }
    return (_jsx(Prose, { className: "max-w-none", children: _jsx(CodeListing, { code: urls.join('\n'), title: urls.length === 1 ? 'Base URL' : 'Base URLs', className: "mt-6" }) }));
}
